module.exports = __webpack_public_path__ + "img/auto_mobile.b8c33a91.jpg";